module.exports = __webpack_public_path__ + "img/goApp.146302d4.png";